const DEFAULT_PARAMS = {
  toolbar: true,
  location: true,
  directories: false,
  status: false,
  menubar: false,
  scrollbars: true,
  resizable: false,
  copyhistory: false,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
};

function buildParams(params) {
  return _(params)
    .map((value, key) => {
      if (value === true) {
        value = 'yes';
      } else if (value === false) {
        value = 'no';
      }

      return `${key}=${value}`;
    })
    .join(',');
}


export default function openTab(url, params = {}, name = '_blank') {
  params = { ...DEFAULT_PARAMS, ...params };

  const _params = buildParams(params);

  const tab = window.open(url, name, _params);

  if (tab) {
    if (tab.moveTo) {
      tab.moveTo(params.left, params.top);
    }

    tab.focus();
  }
}

export function openBlankTab(url) {
  window.open(url, '_blank');
}



// WEBPACK FOOTER //
// ./src/shared/utils/open-tab.js